import React, { Component } from 'react';
import { isMobileOnly } from "react-device-detect";

import { Routes as routes } from '../navigation';
import { Header, Line } from '../components';
import '../css/SwitchAccount.css';

class SwitchAccount extends Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedPractice: '',
      selectedRole: '',
    }
  }

  componentDidMount() {
    if (this.props.userPractices && Object.keys(this.props.userPractices).length === 1) {
      const practiceID = Object.keys(this.props.userPractices)[0];
      this.setState({ ...this.state, selectedPractice: practiceID });
    }
  }

  renderPractices = (userPractices, userRoles) => {
    const practices = userPractices || {};
    const roles = userRoles || {};
    const practiceIDs = Object.keys(practices);

    const practiceRows = practiceIDs.map((practiceID) => {
      const practice = practices[practiceID];
      const roleForThisPractice = roles[practiceID];
      if (roleForThisPractice && roleForThisPractice.approved === false) {
        return null;
      }
      return <div key={practiceID}
                  className={`practice-row-container ${this.state.selectedPractice === practiceID ? 'practice-row-container-selected' : ''}`}
                  onClick={ () => { this.setState({ ...this.state, selectedPractice: practiceID, selectedRole: '' }) }}
              >
        <span style={{ fontSize: 14, color: '#474747' }}>{ practice.name }</span>
      </div>
    })

    return <div>
      { practiceRows }
    </div>
  }

  renderRoles = (userRoles) => {
    if (!this.state.selectedPractice) {
      return null;
    }

    const roles = userRoles || {};
    const rolesToDisplay = roles[this.state.selectedPractice] || {};

    var thisUsersRoles = []
    thisUsersRoles = rolesToDisplay.admin ?  [ ...thisUsersRoles, { label: 'Admin',            role: 'admin'            }] : thisUsersRoles;
    thisUsersRoles = rolesToDisplay.practice_manager ?  [ ...thisUsersRoles, { label: 'Practice Manager', role: 'practice_manager' }] : thisUsersRoles;
    thisUsersRoles = rolesToDisplay.practice_owner   ?  [ ...thisUsersRoles, { label: 'Practice Owner',   role: 'practice_owner'   }] : thisUsersRoles;
    thisUsersRoles = rolesToDisplay.vet              ?  [ ...thisUsersRoles, { label: 'Veterinarian',     role: 'vet'              }] : thisUsersRoles;
    thisUsersRoles = rolesToDisplay.behaviorist      ?  [ ...thisUsersRoles, { label: 'Behaviorist',      role: 'behaviorist'      }] : thisUsersRoles;
    thisUsersRoles = rolesToDisplay.tech             ?  [ ...thisUsersRoles, { label: 'Tech',             role: 'tech'             }] : thisUsersRoles;
    thisUsersRoles = rolesToDisplay.front_desk       ?  [ ...thisUsersRoles, { label: 'Front Desk',       role: 'front_desk'       }] : thisUsersRoles;

    const rolesRows = thisUsersRoles.map((roleObject) => {
      return <input key={roleObject.role}
                    value={roleObject.label}
                    type="submit"
                    className="button-clear"
                    style={{ margin: 5, color: this.state.selectedRole === roleObject.role ? '#1dc2ff' : '', backgroundColor: this.state.selectedRole === roleObject.role ? '#e8f8ff' : '' }}
                    onClick={ () => { this.setState({ ...this.state, selectedRole: roleObject.role }) }}
                  />
    })

    return <div className='flex-container-column' style={{  }}>
      <Line style={{ marginTop: 15, marginBottom: 15 }}/>
      <span style={{ marginLeft: 5, fontSize: 12, color: '#1dc2ff', fontWeight: 'bold' }}>SELECT A ROLE TO SIGN IN AS:</span>
      <div className='flex-container-row' style={{ overflow: 'scroll' }}>
        { rolesRows }
      </div>
    </div>
  }

  renderContinueButton = () => {
    if (this.state.selectedPractice && this.state.selectedRole) {
      return <div className="flex-container-row" style={{ marginTop: 5, justifyContent: 'flex-end' }}>
        <input className="button-default" type="submit" value="Continue"
                onClick={ () => {
                  if (this.state.selectedPractice && this.state.selectedRole) {
                    this.props.contextActions.updatedContextPracticeAndRole(this.state.selectedPractice, this.state.selectedRole);
                  }
                }}
        />
      </div>
    }
  }

  render() {
    let width = isMobileOnly ? 340 : 500;

    return (
      <div className="standard-container" style={{ width: width, minWidth: width, alignSelf: 'center' }}>
        <Header title='Sign In' icon='fas fa-sign-in-alt' />
        <div className='flex-container-column' style={{ padding: 15, paddingTop: 8 }}>
          <span style={{ marginLeft: 5, marginTop: 5, marginBottom: 10, fontSize: 12, color: '#1dc2ff', fontWeight: 'bold' }}>SELECT A PRACTICE TO SIGN IN TO:</span>
          { this.renderPractices(this.props.userPractices, this.props.userRoles) }
          { this.renderRoles(this.props.userRoles) }
          { this.renderContinueButton() }
        </div>
      </div>
    );
  }

}


export default SwitchAccount
